<template>
  <div class="container">
    <el-container>
      <el-header>
        <HeaderComponent />
      </el-header>
      <el-container>
        <el-aside width="200px">
          <AsideMenuComponent />
        </el-aside>
        <el-main>
          <router-view />
          <TimerDialogComponent
            :visible="showNotifiedTask"
            :task="notifiedTask"
            @close="notifyClosed"
            @done="doneScheduleTask"
          />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { LOGIN_PATH } from "../utilis/enum";
import HeaderComponent from "../components/HeaderComponent";
import AsideMenuComponent from "../components/AsideMenuComponent";
import TimerDialogComponent from "../components/TimerDialogComponent";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Index",
  components: { AsideMenuComponent, HeaderComponent, TimerDialogComponent },
  data() {
    return {
      notificationPermission: "default",
    };
  },
  async mounted() {
    await this.selectAllScheduleTask({ userName: this.userName });
    await this.selectScheduleByNum({ userName: this.userName, num: 6 });
  },

  computed: {
    ...mapGetters("scheduleTask", ["showNotifiedTask", "notifiedTask"]),
    ...mapGetters("user", ["userName", "isLoggedIn"]),
  },

  methods: {
    ...mapActions("scheduleTask", [
      "selectScheduleByNum",
      "selectAllScheduleTask",
      "notifyClosed",
      "doneSchedule",
    ]),

    navigateAboutView() {
      this.$router.push("/about");
    },

    async requestPermissionAndNotify() {
      if (!("Notification" in window)) {
        alert("此浏览器不支持桌面通知");
        return;
      }
      try {
        const permission = await Notification.requestPermission();
        this.notificationPermission = permission;
        if (permission === "granted") {
          // 发送测试通知
          new Notification("新提醒", {
            body: "这是一条提醒消息",
          });
        } else {
          alert("您拒绝了通知权限，无法发送通知");
        }
      } catch (error) {
        console.error("请求通知权限失败:", error);
      }
    },

    doneScheduleTask(event) {
      this.doneSchedule(event);
    },
  },

  beforeMount() {
    if (this.isLogin) {
      this.$router.push(LOGIN_PATH);
    }
  },
};
</script>

<style scoped lang="scss">
.el-main {
  padding: 0 !important;
}
</style>
